import { ReactNode } from "react";
import sophieAiLogo from "@/assets/sophie-ai-logo.png";

interface OnboardingLayoutProps {
  children: ReactNode;
  currentStep: number;
  totalSteps: number;
  hideProgress?: boolean;
}

export const OnboardingLayout = ({ children, currentStep, totalSteps, hideProgress = false }: OnboardingLayoutProps) => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header with logo */}
      <header className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-4">
          <img src={sophieAiLogo} alt="Sophie AI" className="h-8" />
        </div>
      </header>

      {/* Progress bar */}
      {!hideProgress && (
        <div className="bg-card border-b border-border">
          <div className="container mx-auto px-4 py-6">
            <div className="flex items-center justify-between max-w-3xl mx-auto">
              {Array.from({ length: totalSteps }).map((_, index) => {
                const stepNum = index + 1;
                const isActive = stepNum === currentStep;
                const isCompleted = stepNum < currentStep;
                
                return (
                  <div key={stepNum} className="flex items-center flex-1">
                    <div className="flex flex-col items-center flex-1">
                      <div
                        className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all ${
                          isActive
                            ? "bg-primary text-primary-foreground scale-110"
                            : isCompleted
                            ? "bg-primary/20 text-primary"
                            : "bg-muted text-muted-foreground"
                        }`}
                      >
                        {stepNum}
                      </div>
                      <span className="text-xs mt-2 text-muted-foreground hidden sm:block">
                        Step {stepNum}
                      </span>
                    </div>
                    {index < totalSteps - 1 && (
                      <div
                        className={`h-0.5 flex-1 mx-2 transition-all ${
                          isCompleted ? "bg-primary" : "bg-muted"
                        }`}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Main content */}
      <main className="flex-1 container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto animate-fade-in">
          {children}
        </div>
      </main>
    </div>
  );
};
